import { Component, Injector } from "@angular/core";
import { Router } from "@angular/router";
import { AfAuctionModel } from "@pattonair/auction-framework";
import { MfBaseComponent, MfTypeInfo, mfTypeIsUndefined } from "@pattonair/material-framework";
import { AucRouteNames } from "../route.names";
import { AucAuctionService } from "../services/auction.service";

const TYPE_INFO: MfTypeInfo = { className: "AucAuctionListComponent" };

@Component({
  selector: "ecom-won-list",
  templateUrl: "./won.list.component.html",
  styleUrls: ["./won.list.component.scss"]
})
export class AucWonListComponent extends MfBaseComponent {

  protected _auctions: AfAuctionModel[] = [];

  public constructor(
    protected override _injector: Injector,
    protected _auctionService: AucAuctionService,
    protected _router: Router,
  ) {
    super(TYPE_INFO, _injector);
    this._getLiveAuctions();
  }

  protected _getLiveAuctions(): void {
    const loading = this._subLoading(this._auctionService.getWonLive(), {
      next: (auctions) => {
        this._auctions = auctions;
        loading.complete();
      },
      error: () => {
        loading.complete();
      },
    });
  }

  protected _goToDetail(auction: AfAuctionModel): void {
    if (!mfTypeIsUndefined(auction) && !mfTypeIsUndefined(auction.id)) {
      this._router.navigate([AucRouteNames.getWonAuctionDetailRouteAuctionId(auction.id)]);
    }
  }
}